const Designs = {
  LOVE_YOU: 'love-you',
  I_CANT_BELIEF: 'i-cant-belief',
  LET_LOVE_GROW: 'let-love-grow',
  BE_MINE: 'be-mine',
  LOVE_YOU_MOM: 'love-you-mom',
  PLANT_MOM: 'plant-mom-1',
  PLANT_MOM_2: 'plant-mom-2',
  MOTHERS_DAY: 'mothers-day',
  CLASS_OF_2024: 'class-of-2024',
  GROW_PLACES: 'grow-places',
  NUMBER_1_PLANT_DAD: '#1-plant-dad',
  PLANT_DADDY: 'plant-daddy',
  OLYMPICS_NO_1_MEDAL: '#1-medal',
  OLYMPICS_USA: 'olympics-usa',
  OLYMPICS_PARIS: 'olympics-paris',
  HAPPY_HOLIDAYS: 'happy-holidays',
  MERRY_XMAS: 'merry-xmas',
  HAPPY_HANNUKAH: 'happy-hannukah',
  CUSTOM_TEXT: 'custom-text',
};

const DesignLabels = {
  [Designs.LOVE_YOU]: 'Love You',
  [Designs.I_CANT_BELIEF]: 'I Cant Belief',
  [Designs.LET_LOVE_GROW]: 'Let Love Grow',
  [Designs.BE_MINE]: 'Be Mine',
  [Designs.LOVE_YOU_MOM]: 'I Love You Mom',
  [Designs.PLANT_MOM]: '#1 Plant Mom',
  [Designs.PLANT_MOM_2]: 'No.1 Plant Mom',
  [Designs.MOTHERS_DAY]: 'Happy Mother\'s Day!',
  [Designs.CLASS_OF_2024]: 'Class of 2024',
  [Designs.GROW_PLACES]: 'Oh the places you\'ll grow',
  [Designs.NUMBER_1_PLANT_DAD]: '#1 Plant Dad',
  [Designs.PLANT_DADDY]: 'Plant Daddy',
  [Designs.OLYMPICS_NO_1_MEDAL]: '#1 Medal',
  [Designs.OLYMPICS_USA]: 'USA 2024',
  [Designs.OLYMPICS_PARIS]: 'Paris 2024',
  [Designs.HAPPY_HOLIDAYS]: 'Happy Holidays!',
  [Designs.MERRY_XMAS]: 'Merry Christmas!',
  [Designs.HAPPY_HANNUKAH]: 'Happy Hannukah!',
  [Designs.CUSTOM_TEXT]: 'Custom Text',
};

const PotColors = {
  GLOSSY_WHITE: 'glossy-white',
  MATTE_WHITE: 'matte-white',
  FUCHSIA: 'fuchsia',
};

const DesignOptions = {
  NONE: 'none',
  DATE_ONLY: 'date_only',
  DATE_AND_TEXT: 'date_and_text',
  CUSTOM: 'custom',
};

const DesignSvgs = {
  [Designs.LOVE_YOU]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Love-You.svg?v=1704712145',
  [Designs.I_CANT_BELIEF]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/I_CANT_BELEAF.svg?v=1704873057',
  [Designs.LET_LOVE_GROW]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/LET_LOVE_GROW.svg?v=1704873057',
  [Designs.BE_MINE]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/BE_MINE.svg?v=1704873056',
  [Designs.LOVE_YOU_MOM]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/I_Love_You_Mom.svg?v=1713766695',
  [Designs.PLANT_MOM]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Number1_Plant_Mom.svg?v=1713766695',
  [Designs.PLANT_MOM_2]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Number1_Plant_Mom_2.svg?v=1713766695',
  [Designs.MOTHERS_DAY]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Happy_Mothers_Day.svg?v=1713766695',
  [Designs.CLASS_OF_2024]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/LR-Grad-Customization_3.svg?v=1717062053',
  [Designs.GROW_PLACES]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/LR-Grad-Customization_2.svg?v=1717062053',
  [Designs.NUMBER_1_PLANT_DAD]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Plant_Dad_Engraving.svg?v=1717400823',
  [Designs.PLANT_DADDY]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Plant_Daddy_Engraving.svg?v=1717400823',
  [Designs.OLYMPICS_USA]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Olympics_USA.svg?v=1721022929',
  [Designs.OLYMPICS_PARIS]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Olympics_Paris_2.svg?v=1721023262',
  [Designs.OLYMPICS_NO_1_MEDAL]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/1_Medal_3.svg?v=1721023890',
  [Designs.HAPPY_HOLIDAYS]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Happy_Holidays.svg?v=1734071995',
  [Designs.MERRY_XMAS]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Merry_Xmas.svg?v=1734071995',
  [Designs.HAPPY_HANNUKAH]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/LR-HOLIDAYS-Engraving.svg?v=1734071727',
};

const DesignAspectRatios = {
  [Designs.OLYMPICS_PARIS]: 0.95,
  [Designs.OLYMPICS_NO_1_MEDAL]: 0.83,
  [Designs.HAPPY_HANNUKAH]: 1,
  [Designs.HAPPY_HOLIDAYS]: 1.66,
  [Designs.MERRY_XMAS]: 1.95,
};

const DesignSwatches = {
  [Designs.CUSTOM_TEXT]: 'https://www.livelyroot.com/cdn/shop/files/engraving_option_custom_text_120x.png?v=17197910317253790976',
  [Designs.LET_LOVE_GROW]: 'https://www.livelyroot.com/cdn/shop/files/LET_LOVE_GROW_120x.png?v=12010497209250877844',
  [Designs.CLASS_OF_2024]: 'https://www.livelyroot.com/cdn/shop/files/engraving_class_24_swatch_120x.png?v=12696503375425472414',
  [Designs.GROW_PLACES]: 'https://www.livelyroot.com/cdn/shop/files/engraving_grow_places_swatch_120x.png?v=2980885468949242341',
  [Designs.PLANT_MOM]: 'https://www.livelyroot.com/cdn/shop/files/Number1_Plant_Mom_2_Swatch_120x.png?v=4099463128520996977',
  [Designs.NUMBER_1_PLANT_DAD]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/engrav12ing__1_plant_dad_swatch.png?v=1717402109',
  [Designs.PLANT_DADDY]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/engraving_plant_daddy_swatch.png?v=1717402109',
  [Designs.OLYMPICS_USA]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Olympics_USA_120x.png?v=1721022392',
  [Designs.OLYMPICS_PARIS]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Olympics_Paris_2_120x.png?v=1721024287',
  [Designs.OLYMPICS_NO_1_MEDAL]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/1_Medal_3_120x.png?v=1721023831',
  [Designs.HAPPY_HOLIDAYS]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Engraving_Swatch_Happy_Holidays.png?v=1734071123',
  [Designs.MERRY_XMAS]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Engraving_Swatch_Xmas.png?v=1734071124',
  [Designs.HAPPY_HANNUKAH]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Engraving_Swatch_Hannukah.png?v=1734071124',
  [Designs.MOTHERS_DAY]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Happy_Mothers_Day_120x.png?v=1713767332',
  [Designs.LOVE_YOU_MOM]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/I_Love_You_Mom_120x.png?v=1713767332',
  [Designs.PLANT_MOM_2]: 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/Number1_Plant_Mom_Swatch_120x.png?v=1713938459',
};

const EnabledDesigns = [
  Designs.CUSTOM_TEXT,
  Designs.MOTHERS_DAY,
  Designs.LOVE_YOU_MOM,
  Designs.PLANT_MOM_2,
  Designs.LET_LOVE_GROW,
];

const designOptionsConfig = {
  [Designs.LOVE_YOU]: DesignOptions.DATE_ONLY,
  [Designs.I_CANT_BELIEF]: DesignOptions.DATE_ONLY,
  [Designs.LET_LOVE_GROW]: DesignOptions.DATE_AND_TEXT,
  [Designs.BE_MINE]: DesignOptions.DATE_AND_TEXT,
  [Designs.LOVE_YOU_MOM]: DesignOptions.DATE_AND_TEXT,
  [Designs.PLANT_MOM]: DesignOptions.DATE_AND_TEXT,
  [Designs.PLANT_MOM_2]: DesignOptions.DATE_AND_TEXT,
  [Designs.MOTHERS_DAY]: DesignOptions.DATE_AND_TEXT,
  [Designs.CUSTOM_TEXT]: DesignOptions.CUSTOM,
  [Designs.CLASS_OF_2024]: DesignOptions.DATE_AND_TEXT,
  [Designs.GROW_PLACES]: DesignOptions.DATE_AND_TEXT,
  [Designs.NUMBER_1_PLANT_DAD]: DesignOptions.DATE_AND_TEXT,
  [Designs.PLANT_DADDY]: DesignOptions.DATE_AND_TEXT,
  [Designs.OLYMPICS_NO_1_MEDAL]: DesignOptions.DATE_AND_TEXT,
  [Designs.OLYMPICS_USA]: DesignOptions.DATE_AND_TEXT,
  [Designs.OLYMPICS_PARIS]: DesignOptions.DATE_AND_TEXT,
  [Designs.HAPPY_HOLIDAYS]: DesignOptions.NONE,
  [Designs.MERRY_XMAS]: DesignOptions.NONE,
  [Designs.HAPPY_HANNUKAH]: DesignOptions.NONE,
};

export {
  Designs,
  DesignLabels,
  DesignOptions,
  DesignSvgs,
  EnabledDesigns,
  DesignSwatches,
  designOptionsConfig,
  PotColors,
  DesignAspectRatios,
};
